export default __webpack_public_path__ + "3746fcf0097b22d48ada53809074ce30.woff2";